import { QueryCache, QueryClient, QueryClientProvider } from "react-query";
import "./App.scss";
import MainRoutes from "./routes/MainRoutes";
import { BrowserRouter } from "react-router-dom";
import { EmailProvider } from "./Context/EmailContext";
import { PageAccessProvider } from "./Context/PageAccessContext";
import { ToastContainer, toast } from "react-toastify";

const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutations: {},
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Above the router's own tree: the sidebar, the route gate and the
            `/home` landing redirect all read the same two page lists from
            here, so they cannot disagree with each other. */}
        <PageAccessProvider>
          <EmailProvider>
            <MainRoutes />
            <ToastContainer
              position="top-center"
              autoClose={2500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </EmailProvider>
        </PageAccessProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
